import React from 'react'
import { connect } from 'react-redux'
import { setInGameAction } from './reducers/reducers'
import { MAX_IMAGE_COUNT } from './init'

const Introduction = (props) => {
    return (
        <div className='callout secondary'>
        	<h3>Identical Faces game</h3>
        	<p>The Identical Faces game is a competition between you and a computer in determining if 2 images belong to the same person or not.</p>
        	<p>You will be shown an image for 2 seconds, and after that, another image. You will determine if the person in the second image is the same person in the previous image.</p>
        	<p>You will be shown { MAX_IMAGE_COUNT } pairs of images.</p>
        	<p>Click the button "NEXT" below when you are ready.</p>
        	<button className='button' onClick={props.next}>Next</button>
        </div>
    )
}

const mapDispatchToProps = (dispatch) => ({
	next: () => dispatch(setInGameAction())
})

export default connect(null, mapDispatchToProps)(Introduction)



// WEBPACK FOOTER //
// ./src/Intro.js